import { useEffect, useRef } from "react";
import { useSelector } from "react-redux";
import { selectUser } from "features/userSlice";
import { getCookie } from "./cookies";
import useSsoSync from "./useSsoSync";

const SSO_COOKIE = "xbadm_session";

const SsoBootstrap = () => {
  const user = useSelector(selectUser);
  const { run } = useSsoSync();
  const triedRef = useRef(false);

  useEffect(() => {
    if (triedRef.current) return;
    if (user) return;
    const session = getCookie(SSO_COOKIE);
    if (!session) return;
    triedRef.current = true;
    run();
  }, [user, run]);

  return null;
};

export default SsoBootstrap;
